<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header-row">
      <div class="modal-title">{{ isEditMode ? 'Edit entry' : 'Add new entry' }}</div>
      <div class="close-button" (click)="onCancel()">
        <img src="assets/img/x.svg" style="width: 24px; height: 24px" alt="close" />
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="form" class="form-content">
      <div class="form-field">
        <div class="field-label">Entry Note</div>
        <div class="textarea-container">
          <textarea
            class="note-textarea"
            placeholder="Type here"
            formControlName="note"
            rows="4"
            (input)="onTextareaInput($event)"></textarea>
        </div>
        <div class="helper-row">
          <img src="assets/img/svg/info-hint.svg" width="20" height="20" class="helper-icon" alt="Info" />
          <span class="helper-text">
            Examples: "Increase deductible if no response by renewal." | "Add fire allocation if ventilation issues
            aren't addressed."
          </span>
        </div>
      </div>
    </form>

    <!-- Footer -->
    <div class="modal-footer-row">
      <button class="cancel-btn" (click)="onCancel()">Cancel</button>
      <button
        class="save-btn"
        [class.disabled]="!form.valid || isSaving"
        [class.enabled]="form.valid && !isSaving"
        (click)="form.valid && !isSaving ? onSave() : null">
        {{ isSaving ? 'Saving...' : isEditMode ? 'Update Journal Entry' : 'Save Journal Entry' }}
      </button>
    </div>
  </div>
</div>
